import { defineComponent, ref, withKeys } from 'vue';
import { useList } from '@/hooks/use-list';
import { DOMAIN_ENV_ENUM, DOMAIN_SYSTEM_ENUM } from '@myna/utils';
import { getDomainList, delDomainConfApi, getDomainEvlList } from '@/api/system-config';
import { IGetDomainListRes, IGetDomainListReq } from '@/api/system-config/type.d';
import EditDialog from './components/edit-dialog';
import { ElMessageBox, ElMessage } from 'element-plus';
import CustomTable from '@/components/custom-table/index';
import { renderColumns } from './tableData';
import usePermissionConfig from './use-permission-config';

export default defineComponent({
  components: {
    CustomTable,
    EditDialog,
  },

  setup() {
    const { params, tableData, tableLoading, handleSearch, handleReset } = useList<
      IGetDomainListRes,
      IGetDomainListReq
    >({
      response: {
        tableDataKey: 'data',
      },
      request: {
        api: getDomainList,
        params: {
          domainSystem: '',
          domainBaseUrl: '',
          domainEnv: '',
        },
      },
    });
    const editConfig = ref({
      visible: false,
      formData: {},
    });
    const handleDelDomain = async (id: string) => {
      try {
        await ElMessageBox.confirm('此操作将删除该域名配置, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        await delDomainConfApi(id);
        ElMessage.success('操作成功');
        handleSearch();
      } catch (e) {
        //
      }
    };
    const handleEditItem = (row?: IGetDomainListRes) => {
      editConfig.value.formData = row || {};
      editConfig.value.visible = true;
    };

    // 环境下拉列表
    const evlList = ref([]);
    const domainEvlList = async () => {
      try {
        const res = await getDomainEvlList();
        evlList.value = res.data || [];
      } catch (e) {
        console.error(e);
      }
    };
    domainEvlList();

    handleSearch();

    const permissionConfig = usePermissionConfig();

    return {
      editConfig,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      params,
      handleEditItem,
      handleDelDomain,
      DOMAIN_ENV_ENUM,
      DOMAIN_SYSTEM_ENUM,
      domainEvlList,
      evlList,
      permissionConfig,
    };
  },
  render() {
    const slots = {
      fheader: ({ collapse }: any) => (
        <el-form
          size="default"
          onKeyup={withKeys(() => this.handleSearch(), ['enter'])}
          label-width="130px"
        >
          <el-form-item label="域名所属系统">
            <el-input
              v-model={[this.params.domainSystem, ['trim']]}
              placeholder="请输入域名所属系统"
              clearable
            />
          </el-form-item>
          <el-form-item label="域名地址">
            <el-input
              v-model={[this.params.domainBaseUrl, ['trim']]}
              placeholder="请输入域名地址"
              clearable
            />
          </el-form-item>
          {collapse && (
            <el-form-item label="环境">
              <el-select v-model={this.params.domainEnv} clearable placeholder="请选择环境">
                {this.evlList.map(item => (
                  <el-option value={item} label={item} key={item} />
                ))}
              </el-select>
            </el-form-item>
          )}
          <el-form-item label-width="0" class="margin-left-20">
            <el-button type="primary" size="default" onClick={() => this.handleSearch()}>
              查询
            </el-button>
            <el-button size="default" onClick={() => this.handleReset()}>
              重置
            </el-button>
          </el-form-item>
        </el-form>
      ),
      header: () => (
        this.$has(this.permissionConfig.CREATE) && <el-button
          type="primary"
          size="default"
          onClick={() => this.handleEditItem()}
        >
          新增域名配置
        </el-button>
      ),
      main: ({ height }: any) => (
        <custom-table
          size="medium"
          data={this.tableData}
          columns={renderColumns(
            this.handleEditItem,
            this.handleDelDomain,
            this.$filters,
            this.$has(this.permissionConfig.UPDATE),
            this.$has(this.permissionConfig.DELETE),
          )}
          height={height}
          key={height}
          v-loading={this.tableLoading}
        />
      ),
    };
    return (
      <div class="error-logs">
        <app-page v-slots={slots} fheader={{ showCollapse: true }} />
        <edit-dialog
          v-model={[this.editConfig.visible, 'visible']}
          form={this.editConfig.formData}
          onRefresh={() => this.handleSearch()}
        />
      </div>
    );
  },
});
